import useSWR from 'swr'
import { EditionId } from 'domain/models/ValueObject/EntityIds'
import { DashboardApiClient } from 'services/dashboard/DashboardApiClient'

const apiClient = new DashboardApiClient()

export const useGetEditionAndEventFromEditionId = ({
  editionId
}: {
  editionId: EditionId | undefined
}) => {
  const { key, fetcher } = apiClient.getEditionAndEventFromEditionId({
    editionId
  })
  return useSWR(key, fetcher)
}
